import { createLivePreviewRequestHandler } from "src/utils/livePreviewHandler";

/**
 * Live preview request handler for `entertainment-events` (collection uses drafts).
 */
export const entertainmentLivePreviewRequestHandler = createLivePreviewRequestHandler(
  ({ serverURL, apiPath, docId }) =>
    `${serverURL}${apiPath}/entertainment-events/${docId}?draft=true`
);
